import { createFileRoute, redirect } from "@tanstack/react-router";

import VerifyTypeTokenPage from "@/components/Verification/VerifyTypeTokenPage";
import { notify } from "@/hooks/useNotifications";
import i18n from "@/providers/i18n";

enum TVerificationType {
  invite = "invite",
  signup = "signup",
  recovery = "recovery",
}

const isTypeValid = (value: string) => value && value in TVerificationType;
const isTokenValid = (value: string) => value && value.length > 50;

export const Route = createFileRoute("/account/verify/$type/$token")({
  beforeLoad: ({ params }) => {
    if (!isTypeValid(params.type) || !isTokenValid(params.token)) {
      notify.error(i18n.t("verify.token-malformed"));
      throw redirect({
        to: "/login",
      });
    }
  },
  component: VerifyTypeTokenPage,
});
